import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {
  TCounterparty,
  TFineryMarketDuty,
  TFineryMarketSettlement,
  TSettlementStatus,
} from '@/api/admin/finery/types';

export const getCounterparty = (): TCounterparty => {
  return {
    id: faker.mersenne.rand(999999),
    name: faker.name.findName(),
  } as TCounterparty;
};

export const getPosition = (): TFineryMarketDuty => {
  return {
    counterparty: getCounterparty(),
    amount: faker.finance.amount(0, 1000, 2),
    asset_code: faker.finance.currencyCode(),
  } as TFineryMarketDuty;
};

export const getPositions = (limit: number): TFineryMarketDuty[] => {
  return loopMap(limit, () => getPosition()) as TFineryMarketDuty[];
};

export const getSettlement = (): TFineryMarketSettlement => {
  const amount = faker.finance.amount(0, 1000, 2);
  const statuses = ['created', 'sended', 'commited', 'cancelled'] as TSettlementStatus[];

  return {
    counterparty: getCounterparty(),
    amount,
    asset_code: faker.finance.currencyCode(),
    ...(faker.datatype.boolean() ? {fee: faker.finance.amount(0, Number(amount), 2)} : {}),
    tx_id: faker.finance.ethereumAddress(),
    comment: faker.lorem.lines(faker.mersenne.rand(3)),
    status: (faker.helpers as any).arrayElement(statuses),
    order_id: faker.mersenne.rand(999999),
    dt: faker.date.recent().toISOString(),
  } as TFineryMarketSettlement;
};

export const getSettlements = (limit: number): TFineryMarketSettlement[] => {
  return loopMap(limit, () => getSettlement()) as TFineryMarketSettlement[];
};
